<template>
  <v-form ref="form">
    <v-row align="baseline">
      <v-col cols="3" md="3">
        <apartment-filter
          v-model="filters.apartments"
          item-text="name"
          item-value="id"
          :label="$t('APARTMENTS.ITEM')"
          multiple
          chips
          small-chips
          deletable-chips
        />
      </v-col>

      <v-col cols="3" md="3">
        <building-filter
          v-model="filters.buildings"
          item-text="name"
          item-value="id"
          :label="$t('BUILDINGS.ITEM')"
          multiple
          chips
          small-chips
          deletable-chips
        />
      </v-col>

      <v-col cols="3" md="3">
        <status-filter
          v-model="filters.statuses"
          item-value="id"
          item-text="name"
          :label="$t('ITEM.STATUS')"
          chips
          multiple
          clearable
          small-chips
          deletable-chips
        />
      </v-col>

      <v-col cols="3" md="3">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mb-1"
              color="grey"
              depressed
              outlined
              @click="reset"
              v-on="on"
            >
              <v-icon>mdi-filter-remove</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
        </v-tooltip>
        <v-btn
          class="mb-1 ml-4"
          type="submit"
          color="primary"
          depressed
          @click.prevent="refreshData"
        >
          {{ $t('BUTTON.FIND') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import ApartmentFilter from './filters/ApartmentFilter.vue';
import BuildingFilter from './filters/BuildingFilter.vue';
import StatusFilter from './filters/StatusFilter.vue';

export default {
  name: 'SmartHomeDevicesListFilters',

  components: {
    ApartmentFilter,
    BuildingFilter,
    StatusFilter
  },

  data() {
    return {
      filters: {}
    };
  },

  methods: {
    refreshData() {
      this.$emit('setRequest', { ...this.filters });
    },

    reset() {
      this.$refs.form.reset();
      this.filters = {};
      this.refreshData();
    }
  }
};
</script>
